var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffersWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 11.381L6.05028 8.90008C6.66495 7.647 8.47154 7.7082 9 9C9.52846 10.2918 11.3351 10.353 11.9497 9.09992L13.1667 6.61905M9 16.5C5.87522 16.5 4.31283 16.5 3.21756 15.7042C2.86383 15.4472 2.55276 15.1362 2.29576 14.7824C1.5 13.6872 1.5 12.1248 1.5 9C1.5 5.87522 1.5 4.31283 2.29576 3.21756C2.55276 2.86383 2.86383 2.55276 3.21756 2.29576C4.31283 1.5 5.87522 1.5 9 1.5C12.1248 1.5 13.6872 1.5 14.7824 2.29576C15.1362 2.55276 15.4472 2.86383 15.7042 3.21756C16.5 4.31283 16.5 5.87522 16.5 9C16.5 12.1248 16.5 13.6872 15.7042 14.7824C15.4472 15.1362 15.1362 15.4472 14.7824 15.7042C13.6872 16.5 12.1248 16.5 9 16.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersWhite);
export default __webpack_public_path__ + "static/media/offersWhite.9a062f36b947c1c30e94ec6e7c1fa0a6.svg";
export { ForwardRef as ReactComponent };